/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabCommentContainer_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_viewer" | "CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "AllCommentsTabCommentContainer_viewer";
};
export type AllCommentsTabCommentContainer_viewer$data = AllCommentsTabCommentContainer_viewer;
export type AllCommentsTabCommentContainer_viewer$key = {
    readonly " $data"?: AllCommentsTabCommentContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabCommentContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'd5f576f4236aa69df168157af43599ba';
export default node;
